import Loading, { LoadingBall } from '@ingka/loading';

const LoadingIndicator = () => {
  return (
    <Loading text="">
      <LoadingBall />
    </Loading>
  );
};

export default LoadingIndicator;
